import React from 'react';

export default function ShareIcon({
  className = '',
  fgColor = '#ffffff',
  width = 14,
  height = 17,
  style = {},
}) {
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="14 4 14 17"
    >
      <path
        d="M20.5046614,6.71504516 L20.5046614,15.2828129 L21.8626615,15.2828129 L21.8626615,6.71327057 L22.9322246,7.78283366 L23.6957427,7.01931553 L21.2213783,4.54495114 L21.1842408,4.58208865 L21.147099,4.5449468 L18.6717226,7.02032317 L19.435553,7.78415357 L20.5046614,6.71504516 Z M18.637401,9.50659743 L14.3936508,9.50659743 L14.3936508,20.2338548 L27.9736514,20.2338548 L27.9736514,9.50659743 L23.7299012,9.50659743 L23.7299012,10.9919101 L26.4459117,10.9919101 L26.4459117,18.7485429 L15.9213905,18.7485429 L15.9213905,10.9919101 L18.637401,10.9919101 L18.637401,9.50659743 Z"
        stroke="none"
        fill={fgColor}
        fillRule="evenodd"
      />
    </svg>
  );
}
